import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserEmailGraphqlService } from './api/user-email-graphql.service';
import { User } from '../types/user';
import { noDefaultErrorHandler } from './interceptors';

@Injectable({
  providedIn: 'root',
})
export class UserEmailService {
  constructor(private userEmailService: UserEmailGraphqlService) {}

  getEmailValidation(
    emailAddress: string,
  ): Observable<ValidationErrors | null> {
    return this.userEmailService.getEmailValidation(emailAddress).pipe(
      map((user: User) => null),
      noDefaultErrorHandler(),
      catchError((err) => {
        if (err.message.includes('email already exists')) {
          return of({
            customError: 'This email address is already in use.',
          });
        } else if (err.message.includes('not a valid format')) {
          return of({
            customError: 'This email address format is invalid.',
          });
        } else {
          return of({
            customError: 'This email address is invalid.',
          });
        }
      }),
    );
  }
}
